import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subject, take, takeUntil } from 'rxjs';
import { LoginModel } from '../../models/login/login.model';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { UserModel } from "../../models/user/user.model";
import { RoleNameEnum } from "../../../admin-panel/enums/role-name.enum";
import { ActivatedRoute, Router } from "@angular/router";
import { RefreshTokenModel } from '../../models/refresh-token/refresh-token.model';

@Component({
  selector: 'app-login-with-refresh-token',
  templateUrl: './login-with-refresh-token.component.html',
  styleUrls: ['./login-with-refresh-token.component.scss']
})
export class LoginWithRefreshTokenComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public loginModel: LoginModel = new LoginModel();
  public errorModel: { [k: string]: any } = {};
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  //#endregion

  //#region Constructor
  constructor(
    public _router: Router,
    public authenticationService: AuthenticationService,
    public messageService: MessageService,
    private _jwtHelperService: JwtHelperService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(async params => {
      localStorage.removeItem('pos_access_token');
      localStorage.removeItem('refresh_token');
      if (params['refresh-token'].length >= 86) {
        const refreshToken = new RefreshTokenModel();
        refreshToken.token = params['refresh-token'] + "==";
        this.authenticationService.refreshToken(refreshToken)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: (response) => {
              const decodedToken = this._jwtHelperService.decodeToken(response.jwtToken);
              const loggedInUser = new UserModel(decodedToken.id, decodedToken.rlnm.split(',').map((x: string) => +x));
              if (loggedInUser.roles.includes(RoleNameEnum.PosGeneralManager) || loggedInUser.roles.includes(RoleNameEnum.PosManager)) {
                localStorage.setItem('pos_access_token', response.jwtToken);
                localStorage.setItem('refresh_token', response.refreshToken);
                this.authenticationService.loginUser.next(loggedInUser);
                this.authenticationService._isManager$.next(true);
                this._router.navigateByUrl('dashboard');
              } else {
                this._router.navigateByUrl('login');
              }
            },
            error: (error) => {
              this._router.navigateByUrl('login');
            }
          })
      } else {
        this._router.navigateByUrl('login');
      }
    });

  }
  //#endregion

  //#region Public Methods
  //#endregion

}
